var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "intelligent-booking-table",
      on: {
        click: function() {
          return (_vm.jobNosDialog.isShow = false)
        }
      }
    },
    [
      _c("cargo-ag-grid", {
        staticClass: "intelligent-booking-table",
        attrs: {
          "grid-params": _vm.gridParams,
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "show-side-bar": true,
          "config-module": _vm.configModule,
          "row-data": _vm.rowData
        },
        on: {
          "update:gridParams": function($event) {
            _vm.gridParams = $event
          },
          "update:grid-params": function($event) {
            _vm.gridParams = $event
          },
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _vm.jobNosDialog.isShow
        ? _c(
            "ul",
            {
              style: {
                position: "fixed",
                left: _vm.jobNosDialog.left + "px",
                top: _vm.jobNosDialog.top + "px",
                cursor: "pointer"
              }
            },
            _vm._l(_vm.jobNosDialog.intelligentDocumentItems, function(
              item,
              index
            ) {
              return _c(
                "li",
                {
                  key: index,
                  style: {
                    backgroundColor: item.isHovered ? "#a5ebff" : "#d7f5ff"
                  },
                  on: {
                    mouseover: function($event) {
                      return _vm.changeColor(index, true)
                    },
                    mouseout: function($event) {
                      return _vm.changeColor(index, false)
                    },
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.jobNoClick(item.jobNo)
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { color: "#2280c4" } }, [
                    _vm._v(_vm._s(item.jobNo))
                  ]),
                  _c("span", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.ColumnUtils.jobBookingStateNew(item.bookingState)
                      )
                    )
                  ])
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm.saveAndBookingDialog.visible
        ? _c(
            "el-dialog",
            {
              attrs: {
                no: "saveAndBookingDialog",
                visible: _vm.saveAndBookingDialog.visible,
                title: _vm.$t("Message.WarmReminder"),
                width: "630px",
                "append-to-body": "",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.saveAndBookingDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { padding: "20px 40px 20px 40px" } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("CargoMsg.Cargo_SelectJobNo")) + " "
                  ),
                  _c("cargo-ag-grid", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.saveAndBookingDialog.jobList.length > 0,
                        expression: "saveAndBookingDialog.jobList.length > 0"
                      }
                    ],
                    staticStyle: { height: "200px" },
                    attrs: {
                      "config-module": "3300013",
                      "grid-options": _vm.saveAndBookingDialog.gridOptions,
                      "column-defs":
                        _vm.saveAndBookingDialog.gridOptions.columnDefs,
                      "row-data": _vm.saveAndBookingDialog.jobList || []
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.saveAndBookingDialog.gridOptions.gridApi =
                          params.api
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.closeDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.saveAndBookingDialog.jobList.length > 0,
                          expression: "saveAndBookingDialog.jobList.length > 0"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.copyHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_UpdateBusinessAgain"))
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }